import {EventEmitter} from 'eventemitter3'

export const textInputWebEmitter = new EventEmitter()
